<template>
    <div>
        Sorry, page was not found.
    </div>
</template>

<script>
    export default {
        name: 'PageNotFound'
    }
</script>

<style lang="scss">
</style>
